import { render, staticRenderFns } from "./UserSuperior.vue?vue&type=template&id=34a87dd3&"
import script from "./UserSuperior.vue?vue&type=script&lang=js&"
export * from "./UserSuperior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports